import { useAxios } from "../base/useAxios";
import { type APIResponse } from "@/models/response/response";
import { type UserLogin, type UserData, type Token, type UserCredentials } from "@/models/users";

export function useAuth() {
  const api = useAxios();

  async function signIn(
    data: UserLogin
  ): Promise<APIResponse<UserData & Token>> {
    return api.$post("/login/portal", data);
  }

  //NOTE - this is the call to handle the acs_callback success
  async function samlSignInApi(
    data: any
  ): Promise<APIResponse<any>> {
    return api.post("/saml/verifyToken/login", data);
  }

  async function verifyLoginTokenApi(
    data: any
  ): Promise<APIResponse<any>> {
    return api.post("/verifytoken", data);
  }

  async function verifyExternalTokenApi(
    data: any
  ): Promise<APIResponse<any>> {
    return api.post("/verifyexternaltoken", data);
  }

  async function logoutUserApi(
    data: any
  ): Promise<APIResponse<any>> {
    return api.post("/logout", data);
  }

  return {
    signIn,
    samlSignInApi,
    verifyLoginTokenApi,
    verifyExternalTokenApi,
    logoutUserApi
  };
}
